import { useSSRSelector } from '@/redux/ssrStore';
import { useEffect, useState } from 'react';
import { useGetTypeIdFromCanonicalDataStore } from 'src/containers/Collections/useGetTypeIdFromCanonicalDataStore';

export const CategoryNameComp = ({ classes = '', ...props }) => {
  const [activeCategoryName, setActiveCategoryName] = useState(null);

  const {
    catalogData: { categories, productTags },
  } = useSSRSelector((state) => ({
    catalogData: state.catalogReducer,
  }));

  const { typeId } = useGetTypeIdFromCanonicalDataStore(props?.config?.category_id);

  useEffect(() => {
    if (categories.length > 0 || productTags.length > 0) {
      const allCategories = [...(productTags || []), ...(categories || [])];
      const catId = typeId;
      if (catId) {
        const activeCatIndex = allCategories.findIndex((el) => el.id === Number(catId));
        setActiveCategoryName(allCategories[activeCatIndex]?.name || 'Available Items');
      }
    }
  }, [categories, productTags, typeId]);

  return <h1 className={`category-name ${classes || ''}`}>{activeCategoryName}</h1>;
};
